// Modules
import React from 'react'

// Routes
import Routes from './routes/Main'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './TwoFactorAuthentication.scss'

// Page: Two-factor authentication
function TwoFactorAuthentication () {
	// Data
	// const { translate } = useLanguage('pages.twoFactorAuthentication')

	// Render
	return (
		<Page
			isPublic
			name="two-factor-authentication">
			<Routes />
		</Page>
	)
}

// Export
export default TwoFactorAuthentication
